//
//
//
//
//
//
//
//
//
export default {
  name: 'Description',
  props: {
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};